import {KTSVG} from '_metronic/helpers'
import React from 'react'

interface Props {}

const supportLink = 'https://intercom.help/corksy/en/'

export const SupportTicket: React.FC<Props> = (props) => {
  const handleClick = () => {
    window.open(supportLink, '_blank')
  }
  return (
    <div className='d-flex align-items-center ms-1 ms-lg-3' id='kt_header_subscription_menu_toggle'>
      <div
        className='cursor-pointer symbol '
        data-kt-menu-trigger='click'
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
        data-kt-menu-flip='bottom'
      >
        <div className='btn btn-active-light-primary d-flex' onClick={handleClick}>
          <KTSVG
            path='/media/icons/duotune/general/gen016.svg'
            className='svg-icon-dark svg-icon-1'
          />
          <span className='text-bolder'>Help Center</span>
        </div>
      </div>
    </div>
  )
}

export default SupportTicket
